export function hasCompletedServiceOnboarding(userData = {}) {
  if (!userData || typeof userData !== "object") return false;
  const flag =
    userData.service_onboarding_completed ??
    userData.serviceOnboardingCompleted;
  return flag === true || flag === 1 || String(flag).toLowerCase() === "true";
}

/** Returning clients skip category/service onboarding after login. */
export function shouldSkipSelectAccount(userData = {}) {
  return hasCompletedServiceOnboarding(userData);
}

export function markServiceOnboardingCompletedInStorage() {
  try {
    const raw = localStorage.getItem("USER_DATA");
    const userData = raw ? JSON.parse(raw) : {};
    const next = { ...userData, service_onboarding_completed: true };
    localStorage.setItem("USER_DATA", JSON.stringify(next));
    return next;
  } catch {
    return null;
  }
}
